<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" :rules="ruleValidate">
      <el-form-item label="代理商：" prop="userId" label-width="151px">
        <el-select v-model="ruleForm.userId" filterable placeholder="公司名" style="width: 420px" @change="agentSelectedValue">
          <el-option v-for="item in agentList" :key="item.userId" :label="'['+item.username+']-'+item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流量池：" prop="poolId" label-width="151px">
        <el-select v-model="ruleForm.poolId" filterable placeholder="流量池" style="width: 420px">
          <el-option v-for="(item,index) in poolList" :key="index" :label="item.poolName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="沉默期：" prop="dateType" label-width="151px">
        <el-radio-group v-model="ruleForm.dateType">
          <el-radio label="1">按（月）</el-radio>
          <el-radio label="2">自定义时间</el-radio>
        </el-radio-group>
        <span slot="label">
          <el-tooltip content="沉默期指流量池中卡的最晚激活时间" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
          沉默期：
        </span>
      </el-form-item>
      <el-form-item prop="silenceTime" v-if="ruleForm.dateType=='1'" label-width="151px">
        <el-input-number v-model="ruleForm.silenceTime" :min="0"></el-input-number>
        <p class="alert-tip">沉默期设置为1个月时，激活时间为下个月的1号凌晨，设置成2个月时，激活时间为下下个月的1号凌晨，依次类推</p>
      </el-form-item>
      <el-form-item prop="planActiveTime" v-if="ruleForm.dateType=='2'" label-width="151px">
        <el-date-picker v-model="ruleForm.planActiveTime" value-format="yyyy-MM-dd" type="date" placeholder="卡计划激活时间"></el-date-picker>
        <p class="alert-tip">自定义卡的最晚激活时间</p>
      </el-form-item>
      <el-form-item label="ICCID：" prop="iccids" label-width="151px">
        <el-input v-model="ruleForm.iccids" type="textarea" placeholder="以回车键分割ICCID" rows="6" style="width:420px;font-size:14px" ></el-input>
      </el-form-item>
      <el-form-item label="ICCID：" prop="startIccid" label-width="151px">
        <el-input v-model="ruleForm.startIccid" style="width: 200px;margin-right: 10px;" placeholder="包含开始值"></el-input>
        <span>-</span>
        <el-input v-model="ruleForm.endIccid" style="width: 200px;margin-left: 10px;" placeholder="包含终止值"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="submitForm()" v-hasPermi="['pondManage:allocation']">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { agentDataList } from "@/api/api.js";
import { poolGetFlowPoolList } from "@/api/api.js";
import { poolAssignPoolCard } from "@/api/api.js";
export default {
  name:"pondTransfer",
  data() {
    return {
      ruleForm: {
        dateType:"1",
        silenceTime:0,
        poolId:undefined
      },
      agentList:[],
      poolList:[],
      ruleValidate:{
        userId:[
          { required: true, message: "请选择公司名", trigger: "blur" },
        ],
        poolId:[
          { required: true, message: "请选择流量池", trigger: "blur" },
        ],
        dateType:[
          { required: true, message: "沉默期不能为空", trigger: "blur" },
        ]
      }
    };
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'pondTransfer'){
          this.initParams();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm,
            iccids:this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
          };
          poolAssignPoolCard(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "已提交卡分配，请在任务中心查看进度",
              duration: 1000,
              offset:30
            });
            setTimeout(()=>{
              this.ruleForm = {
                dateType:"1",
                silenceTime:0,
                poolId:undefined
              };
              this.$router.push(`/taskCenter/missionList`);
            },1000)
          })
        }
      })
    },
    // 获取流量池代理商
    initData(){
      agentDataList({commissionModel:'2'}).then(res => {
        this.agentList = res.data.data;
      })
    },
    // 切换池子
    agentSelectedValue(userId){
      this.ruleForm.poolId = undefined;
      let status = "1";
      poolGetFlowPoolList({userId,status}).then(res=>{
        this.poolList = res.data.data;
      })
    },
    initParams(){
      let userId = this.$route.params && this.$route.params.userId;
      let poolId = this.$route.params && this.$route.params.poolId;
      if(!!poolId){
        this.ruleForm.userId = userId
        let status = "1";
        poolGetFlowPoolList({userId,status}).then(res=>{
          this.poolList = res.data.data;
          this.ruleForm.poolId = poolId
        })
      }
    }

  },
  created() {
   this.initData();
   this.initParams();
  },
};
</script>
<style scoped lang="less">
.content{
  .alert-tip{
    padding: 6px 0px;
    width: 420px;
    color: #909399;
    font-size: 13px;
    line-height: 26px;
  }
}
</style>
